import { BASE_URL_API, BASE_URL_ONLINE_DOCS, DOC_HOST, } from '../../../base/constants/cgi-base';
import docHostProxy from '../../common/utils/doc-host-proxy';
// 轮询看看微信登录是否成功
export var UPDATE_WECHAT_LOGIN_QRCODE_STATUS = "".concat(docHostProxy(DOC_HOST), "/v2/cgi-bin/online_docs/polling");
// 获取Polling cachekey
export var POLLING_KEY_CREATE = "".concat(BASE_URL_API, "polling/key/create");
// 腾讯文档微信登录二维码（小程序）
export var WXQRCODE = "".concat(DOC_HOST, "/cgi-bin/online_docs/wxqrcode");
// 检查QQ登录是否成功
export var CHECK_QQ_LOGIN = "".concat(BASE_URL_ONLINE_DOCS, "user_info");
// QQ登录接口
export var QQ_LOGIN = "".concat(DOC_HOST, "/api/user/qq/login");
// QQ互联登录接口
export var QQ_OAUTH_LOGIN = "".concat(docHostProxy(DOC_HOST), "/api/user/oauth/qq/login");
// 企业微信登录
export var WEWORK_LOGIN = "".concat(BASE_URL_API, "work_weixin/login");
// 微信公众号登录 或 H5登录
export var WECHAT_OFFICIAL_ACCOUNT_OR_H5_LOGIN = "".concat(DOC_HOST, "/api/user/login/wxqrcode");
